import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion, AnimatePresence } from "framer-motion";

const NAV_ITEMS = [
  { label: "Início", path: "/" },
  { label: "Serviços", path: "/servicos" },
  { label: "Como Funciona", path: "/como-funciona" },
  { label: "Sobre", path: "/sobre" },
  { label: "Para Famílias", path: "/para-familias" },
  { label: "Trabalhe Conosco", path: "/trabalhe-conosco" },
  { label: "Contato", path: "/contato" },
];

const WHATSAPP_URL = "https://wa.me/5521974615899?text=Olá!%20Gostaria%20de%20solicitar%20uma%20avaliação.";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-background/95 backdrop-blur-md border-b border-border">
      {/* Top bar */}
      <div className="bg-primary">
        <div className="container flex items-center justify-between py-2 text-sm text-primary-foreground">
          <span className="hidden md:block font-body">Cuidado humanizado para quem você ama</span>
          <div className="flex gap-3 w-full md:w-auto justify-center md:justify-end">
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
              <Button size="sm" variant="secondary" className="text-xs font-semibold h-7">
                Solicitar Avaliação
              </Button>
            </a>
            <Link to="/trabalhe-conosco">
              <Button size="sm" variant="outline" className="text-xs font-semibold h-7 border-primary-foreground/60 text-primary-foreground bg-transparent hover:bg-primary-foreground/20">
                Trabalhe Conosco
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <div className="container flex items-center justify-between py-3">
        <Link to="/" className="flex items-center gap-2">
          <img src="/amparo_logo.png" alt="Amparo & Aconchego" className="h-12 w-auto object-contain" />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${location.pathname === item.path
                ? "text-primary bg-sage"
                : "text-muted-foreground hover:text-foreground hover:bg-muted"
                }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* Mobile toggle */}
        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile nav */}
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden border-t border-border bg-background"
          >
            <div className="container py-4 flex flex-col gap-1">
              {NAV_ITEMS.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setOpen(false)}
                  className={`px-4 py-3 rounded-md text-sm font-medium transition-colors ${location.pathname === item.path
                    ? "text-primary bg-sage"
                    : "text-muted-foreground hover:text-foreground hover:bg-muted"
                    }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
